(function() {
    'use strict';

    angular
        .module('formonlineApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
